import EventEmitter from '@/utils/EventEmitter';

const Plugin = {
  install(app) {
    if (this.installed) return;

    this.installed = true;

    app.config.globalProperties.$eventBus = new EventEmitter();
  },
};

export default Plugin;
